/**
 * Date-extensions locale English (New Zealand) [en-nz]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('en-nz', {
    monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    monthShortNames: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    dayNames: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    dayShortNames: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
});
